<top-navig [display]="true" [displayLogo]="false" title="Commander"></top-navig>
<div class="div-blog"></div>
<div class="modes">
    <div class="container head">
        <div class="form">
            <div>
                <div class="d-flex orderTypes text-center">
                    <ng-container *ngIf="orderTypes.length>0">
                        <div class="check-group check-group-modes" *ngFor="let type of orderTypes;let i=index">
                            <input type="radio" class="filter-address" [name]="'filter'+i" [id]="'filter'+i"
                                [value]="type.id" [(ngModel)]="orderType" (change)="changeOrderType($event)">
                            <label for="filter-address text-center" [for]="'filter'+i">
                                <img class="img" [src]="'assets/images/'+type.id+'.png'" width="75px" alt="">
                                <span>
                                    {{type.label}}
                                </span>
                            </label>
                        </div>
                    </ng-container>
                </div>
                <ng-container *ngIf="times.length>0">
                    <div class="d-flex align-items-center orderProg">
                        <label class="time mr-2" for="orderProg">Souhaitée pour : </label>
                        <div class="orderP">
                            <div class="select">
                                <select width="200px" name="orderProg" id="orderProg" [(ngModel)]="orderProg"
                                    class="times">
                                    <option [value]="null">Selectionner ...</option>
                                    <option *ngFor="let time of times" [value]="time">{{time  | date :'HH:mm'}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="alert" *ngIf="timeErreur">
                        {{timeErreur}}
                    </div>
                    <fieldset class="autocomplete-address">
                        <div *ngIf="orderType && orderType==1" class="login">
                            <div class="form-content">
                                <div class="form-group" *ngIf="addresses?.length>0">
                                    <div class="addresses">
                                        <div class="select">
                                            <select id="soflow" name="address" [(ngModel)]="indexAdd" #s
                                                (change)="change(s.value)">
                                                <option class="option" [value]="-1">Nouvelle adresse</option>
                                                <option class="option" *ngFor="let address of addresses;let i=index"
                                                    value="{{i}}">
                                                    {{address.streetNumber}} {{address.streetName}}
                                                    <span *ngIf="address.city || address.postalCode">( {{address.city}}
                                                        {{address.postalCode}})</span>
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <label *ngIf="amountMiniDelivery>0 && indexAdd>=0" class="time mr-2">Min de la
                                        commande : {{amountMiniDelivery}} €</label>
                                </div>
                                <ng-container *ngIf="indexAdd ==-1 || addresses?.length==0">
                                    <div class="form-group">
                                        <div class="addresses">
                                            <div class="select">
                                                <select *ngIf="authorizedCities?.length>0" id="zone" name="zone" #z
                                                    (change)="setCity(z.value)" [(ngModel)]="indexZone">
                                                    <option class="option" value="-1">--- Sélectionner une zone ---
                                                    </option>
                                                    <option class="option"
                                                        *ngFor="let zone of authorizedCities;let i=index" value="{{i}}">
                                                        {{zone.postalCode}} {{zone.name}}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <label *ngIf="amountMiniDelivery>0 && indexZone>=0" class="time mr-2">Min de la
                                            commande : {{amountMiniDelivery}} €</label>
                                    </div>
                                    <div *ngIf="zonetext" [innerHtml]="zonetext|safeHtml"></div>
                                    <div id="u" class="form-group mr-3">
                                        <input id="streetNumber" class="form-control" [(ngModel)]="address.streetNumber"
                                            spellcheck=false name="streetNumber" type="text" size="18" required="">
                                        <span class="form-highlight"></span>
                                        <span class="form-bar"></span>
                                        <label for="streetNumber" class="float-label">Num de la rue <span
                                                class="required">*</span></label>
                                    </div>
                                    <div class="form-group ml-1" style="flex:1">
                                        <input id="streetName" class="form-control" [(ngModel)]="address.streetName"
                                            spellcheck=false name="streetName" type="text" size="18" required="">
                                        <span class="form-highlight"></span>
                                        <span class="form-bar"></span>
                                        <label for="streetName" class="float-label">Nom de la rue <span
                                                class="required">*</span></label>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </fieldset>
                    <br>
                    <fieldset class="autocomplete-input">
                        <button (click)="validate()" type="submit" class="btn">
                            Terminer
                        </button>
                    </fieldset>
                </ng-container>
                <ng-container *ngIf="!loading && times.length==0">
                    <div class="alert">
                        Les commandes <ng-container *ngIf="orderType==1">en livraison</ng-container>
                        <ng-container *ngIf="orderType==3">à emporter</ng-container>
                        <ng-container *ngIf="orderType==2">sur place</ng-container> ne sont plus disponible pour
                        aujourd'hui.
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
<top-navig display="true" [displayFilter]="false" [displayLogo]="false" title="Commander"></top-navig>